import React, { Component } from 'react';
import SearchInput, {createFilter} from 'react-search-input'
import { connect } from 'react-redux'
import { setSearchData } from '../../redux/actions/searchAction';
import {Input} from 'reactstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { extendMoment } from 'moment-range';
import 'moment/locale/nl';
import _lodash from 'lodash/array'

import 'react-datepicker/dist/react-datepicker.css';
class Search extends Component {

	constructor (props, context) {
	    super(props, context)
	    this.state = {
	      searchTerm: '',
		  data: false,
		  objectFilters: {},
		  date_from: false,
		  date_till: false,
		  daterange_filter_complete:false
	    }
	    this.searchUpdated = this.searchUpdated.bind(this)
	    this.KEYS_TO_FILTERS = this.props.keys_to_filter;
	    this.data = this.props.data;
	    this.renderMetaFilters = this.renderMetaFilters.bind(this);
	    this.changeFromDate = this.changeFromDate.bind(this);
	    this.changeTillDate = this.changeTillDate.bind(this);
	    this.textfieldChanged = this.textfieldChanged.bind(this);
	    this.searchInput = this.props.searchInput;
		this._resetSearch = this._resetSearch.bind(this);
	     // -- set locale

        this.moment = extendMoment(moment);
 		this.moment.locale('nl')

  	}

  	componentDidMount() {
		const searchScope = localStorage.getItem('searchScope');

		if ( searchScope ) {
			let jsonData = JSON.parse(localStorage.getItem('scopedSearchData'));
			if ( jsonData ) {
				if ( jsonData[searchScope] ) {
					this.setState({
						...this.state,
						...jsonData[searchScope]
					}, this.searchUpdated)
				}
			}
		}
		/*
  		if(this.searchInput) {
  			this.searchUpdated(this.searchInput);
  		}*/
  	}

  	componentDidUpdate(prevProps, prevState) {
		const searchScope = localStorage.getItem('searchScope');
		let jsonData = JSON.parse(localStorage.getItem('scopedSearchData'));
		if ( searchScope ) {
			if ( this.state.searchTerm ) {
				jsonData = {
					...jsonData,
					[searchScope] : {
						...jsonData[searchScope],
						searchTerm : this.state.searchTerm
					}
				}


			} else {
				jsonData = {
					...jsonData,
					[searchScope] : {
						...jsonData[searchScope],
						searchTerm : ''
					}
				}
			}

			if ( this.state.objectFilters ) {
				jsonData = {
					...jsonData,
					[searchScope] : {
						...jsonData[searchScope],
						objectFilters : {
							...this.state.objectFilters
						}
					}
				}
			}
			localStorage.setItem('scopedSearchData', JSON.stringify(jsonData));
		}



		if ( JSON.stringify(this.props.searchData) !== JSON.stringify(prevProps.searchData) ) {
		
			if ( this.state.searchTerm ) {
				
				this.searchUpdated(this.state.searchTerm);
			}
		}
  	}


  	searchUpdated(term = false, objectFilters = false, filterArrayKey = false, searchTerms = false) {
	
		if(term !== false) {
			this.setState({searchTerm: term})
		}

		let data = false;

		data = this.props.data;

		this.KEYS_TO_FILTER = this.props.keys_to_filter;

		if(!data) {
			return;
		}

		if(objectFilters){
//			  console.log(this.state.objectFilters)
			  if(this.state.objectFilters[filterArrayKey]) {
				  let state = this.state;
				  delete state.objectFilters[filterArrayKey];

				  this.setState(state);

				  data = this.filterByProps(data, state.objectFilters);
			  }else{


				  this.setState({
					  objectFilters: {
						  ...this.state.objectFilters,
						  [filterArrayKey] : {
							  filterKey : objectFilters.key,
							  filterValue : objectFilters.value
						  }
					  }

				  })

				  let objectFiltersObj = this.state.objectFilters;

					  objectFiltersObj[filterArrayKey] = {
						 filterKey : objectFilters.key,
						 filterValue : objectFilters.value
					 }

					 data = this.filterByProps(data, objectFiltersObj);

			  }


		  }else if(Object.keys(this.state.objectFilters).length > 0) {
			  data = this.filterByProps(data, this.state.objectFilters);
		  }


		  if(term || this.state.searchTerm) {
			  data = data.filter(createFilter(this.state.searchTerm ? this.state.searchTerm : term, this.KEYS_TO_FILTERS))
		  }


		  if(searchTerms || this.state.searchTerms) {
		  		let termsToFilter = this.state.searchTerms;
		  		if(searchTerms) {
		  			termsToFilter = searchTerms;
		  		}

		  		 for (let key in termsToFilter) {
				    if (termsToFilter.hasOwnProperty(key)) {
				       	let searchFor = termsToFilter[key];

				       	let keysToFilter = [];
				       	keysToFilter.push('metaDataCategorized.'+key);

				        data = data.filter(createFilter(searchFor, keysToFilter))
				    }
				}
		  }


		  let dateFilteredData = [];
		  let useDateFilteredData = false;
		  if(this.state.date_from && this.state.date_till) {
			 useDateFilteredData = true;
			  const range = this.moment.range(this.state.date_from.format('YYYY-MM-DD'), this.state.date_till.add(1, 'day').format('YYYY-MM-DD'));
			  data.forEach((item, i) => {
				let curDate = this.moment(item.date_send);
				if(range.contains(curDate)) {
					 dateFilteredData.push(item);
				 }
			  });
		  }

		  if (useDateFilteredData ) {
			  this.props.updateSearchData(dateFilteredData);
		  } else {
			  this.props.updateSearchData(data);
		  }

      //this.props.updateSearchData(data);
  	}

	filterByProps(data, objectFilters) {
		let filteredData = [];
		let endResult = [];

		if(Object.keys(objectFilters).length <= 0) {
			return data;
		}

		filteredData = Object.keys(objectFilters).map(function(key, value) {

			let searchKey = objectFilters[key]['filterKey'];
			let searchValue = objectFilters[key]['filterValue'];

			if(filteredData.length)
				data = _lodash.flatten(filteredData);



			let filters = data.filter(function(data) {
				return data[searchKey] === searchValue ? true : false;
			})

			return filters;
		})

			const lastKey = filteredData.length - 1;

			if(filteredData[lastKey]) {
				for(let j = 0; j <= filteredData[lastKey].length; j++) {
					if(filteredData[lastKey][j]) {
						endResult.push(filteredData[lastKey][j]);
					}
				}
			}


		return endResult;
	}



	mapFilters(filter, key) {
		switch(this.props.filters[filter]['type']) {
			case 'checkbox':
				return (
					<div className="checkbox__container" key={key}>
			          <label>
			            <Input  className="input__checkbox--search" onChange={(e) => this.searchUpdated(false, this.props.filters[filter], this.props.filters[filter]['key']+'_'+this.props.filters[filter]['value'])} type="checkbox" name={this.props.filters[filter]['keyName'] ? this.props.filters[filter]['keyName'] : this.props.filters[filter]['key']} lookfor={this.props.filters[filter]['value']} />
						&nbsp;{this.props.filters[filter]['name']}

			          </label>
			        </div>
				)
			default:
				return('')
		}
	}

	checkboxChanged(e) {
		let term = e.target.value;
		if(!e.target.checked) {
			term = '';
		}

		let searchTerms = {
					...this.state.searchTerms,
					[e.target.getAttribute('searchkey')] : term
				}

		if(term === '') {
			delete searchTerms[e.target.getAttribute('searchkey')]
		}
		this.setState({
			...this.state,
			searchTerms: searchTerms
		})

		this.searchUpdated(false, false, false, searchTerms);
	}

	textfieldChanged(e) {
		let term = e.target.value;
		let searchTerms = {
					...this.state.searchTerms,
					[e.target.getAttribute('searchkey')] : term
				}

		if(term === '') {
			delete searchTerms[e.target.getAttribute('searchkey')]
		}
		this.setState({
			...this.state,
			searchTerms: searchTerms
		})

		this.searchUpdated(false, false, false, searchTerms);
	}

	renderCheckboxFields(value, key, filter) {

		return (
			<label key={key}>
	            <Input value={value} searchkey={filter} className="input__checkbox--search" type="checkbox"  onChange={(e) => this.checkboxChanged(e)}/>
				&nbsp;{value}
          	</label>
		)
	}

	renderTextfield(key, name) {

		return (
			<label key={name}>
	            <Input className="input__text--search input--unstyled" searchkey={key} type="text" onChange={(e) => this.textfieldChanged(e)} />
          	</label>
		)
	}

	renderDatefield(key, name) {

		return (
			<label key={name}>
	            <Input className="input__text--search input--unstyled" placeholder="DD-MM-YYYY" searchkey={key} type="text" onChange={(e) => this.textfieldChanged(e)} />
          	</label>
		)
	}

	renderMetaFilters(filter, key, returnType) {
		const filters = this.props.renderMetaFilters[filter];
		const type = filters.type;

		if(type !== returnType) {
			return;
		}
		return(
			<div className={"rendered__filter__column rendered__filter__column--" + returnType} key={key}>
				<p>{this.props.renderMetaFilters[filter]['name']}</p>
				{type === 'checkbox' ? filters.values.map((value, key) => this.renderCheckboxFields(value, key, filter)) : ''}
				{type === 'textfield' ? this.renderTextfield(filter, filters.name) : ''}
				{type === 'date' ? this.renderDatefield(filter, filters.name) : ''}
			</div>
		)

	}



	changeFromDate(date) {
	
	    this.setState({
	      ...this.state,
	      date_from: date
	  }, this.searchUpdated);
	}

	changeTillDate(date) {
		
	    this.setState({
	      ...this.state,
	      date_till: date
	    }, this.searchUpdated);
	}

	_resetSearch() {

		this.props.updateSearchData(this.props.data);
		this.setState({searchTerm: false})


	}

  	render() {
  		return (
  			<div>
				{this.props.displayCross ? <button className="search-reset" onClick={this._resetSearch}><i className="fa fa-times"></i></button> : null}
  				<SearchInput placeholder={this.props.placeholder ? this.props.placeholder : 'Zoeken'} value={this.state.searchTerm ? this.state.searchTerm : ''} className="filter__input" inputClassName="form-control input__text--search  input--unstyled" onChange={this.searchUpdated} />

				{this.props.renderMetaFilters ? Object.keys(this.props.renderMetaFilters).map((filter, key) => this.renderMetaFilters(filter,key, 'checkbox')) : ''}
  				{this.props.renderMetaFilters ? Object.keys(this.props.renderMetaFilters).map((filter, key) => this.renderMetaFilters(filter,key, 'textfield')) : ''}
  				{this.props.renderMetaFilters ? Object.keys(this.props.renderMetaFilters).map((filter, key) => this.renderMetaFilters(filter,key, 'date')) : ''}
				<div className="filter__input">{this.props.componentHandledFilters ? Object.keys(this.props.componentHandledFilters).map((filter, key) => this.props.componentMapFilters(filter, key)) : ''}</div>
				<div className="filter__input">{this.props.filters ? Object.keys(this.props.filters).map((filter, key) => this.mapFilters(filter, key, this.props.filters)) : ''}</div>

  				{this.props.showDateRange ?
  					<span>
  						<div className="datepickers__wrapper">
  							<div className="datepicker__single">
  								<DatePicker placeholderText="Verzenddatum bericht van" dateFormat="DD-MM-YYYY" selected={this.state.date_from ? this.state.date_from : null}  onChange={date => this.changeFromDate(date)} shouldCloseOnSelect={true} locale='nl-nl'  />
							</div>
		  					<div className="datepicker__single">
		  						<DatePicker placeholderText="Verzenddatum bericht tot" dateFormat="DD-MM-YYYY" selected={this.state.date_till ? this.state.date_till : null}  onChange={date => this.changeTillDate(date)} shouldCloseOnSelect={true} locale='nl-nl'  />
		  					</div>
		  				</div>
	  				</span>
  				: ''
  				}
  			</div>
  		)
  	}


}
function mapStateToProps(state, ownProps) {

    return {
        searchData: state.SearchDataReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSearchData: (data) => dispatch(setSearchData(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Search)



// WEBPACK FOOTER //
// ./src/components/Search/index.js